if (!customElements.get('product-need-finder')) {
  customElements.define(
    'product-need-finder',
    class ProductNeedFinder extends HTMLElement {
      constructor() {
        super();
        this.track = this.querySelector('[data-finder-track]');
        this.items = Array.from(this.querySelectorAll('[data-finder-item]'));
        this.previousButton = this.querySelector('[data-finder-previous]');
        this.nextButton = this.querySelector('[data-finder-next]');
        this.activeIndex = 0;
        this.scrollFrame = null;
        this.handlePreviousClick = () => this.goTo(this.activeIndex - 1);
        this.handleNextClick = () => this.goTo(this.activeIndex + 1);
        this.handleTrackScroll = () => this.handleScroll();
        this.handleResize = () => this.updateControls();
      }

      connectedCallback() {
        if (!this.track || this.items.length === 0) return;

        this.previousButton?.addEventListener('click', this.handlePreviousClick);
        this.nextButton?.addEventListener('click', this.handleNextClick);
        this.track.addEventListener('scroll', this.handleTrackScroll, { passive: true });
        window.addEventListener('resize', this.handleResize);
        this.updateControls();
      }

      disconnectedCallback() {
        this.previousButton?.removeEventListener('click', this.handlePreviousClick);
        this.nextButton?.removeEventListener('click', this.handleNextClick);
        this.track?.removeEventListener('scroll', this.handleTrackScroll);
        window.removeEventListener('resize', this.handleResize);
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      }

      handleScroll() {
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => {
          const trackEdge = this.track.getBoundingClientRect().right;
          let nearestIndex = 0;
          let nearestDistance = Number.POSITIVE_INFINITY;

          this.items.forEach((item, index) => {
            const distance = Math.abs(item.getBoundingClientRect().right - trackEdge);
            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestIndex = index;
            }
          });

          this.activeIndex = nearestIndex;
          this.updateControls();
        });
      }

      goTo(index) {
        const nextIndex = Math.max(0, Math.min(index, this.items.length - 1));
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.items[nextIndex]?.scrollIntoView({
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'start'
        });

        this.activeIndex = nextIndex;
        this.updateControls();
      }

      updateControls() {
        const hasOverflow = this.track.scrollWidth > this.track.clientWidth + 2;
        const trackRect = this.track.getBoundingClientRect();
        const firstRect = this.items[0].getBoundingClientRect();
        const lastRect = this.items[this.items.length - 1].getBoundingClientRect();
        const atStart = Math.abs(firstRect.right - trackRect.right) <= 3;
        const atEnd = Math.abs(lastRect.left - trackRect.left) <= 3;

        if (this.previousButton) {
          this.previousButton.hidden = !hasOverflow;
          this.previousButton.disabled = atStart;
        }

        if (this.nextButton) {
          this.nextButton.hidden = !hasOverflow;
          this.nextButton.disabled = atEnd;
        }
      }
    }
  );
}
